import type { ReactNode } from 'react'

import {
  type CompareFilter,
  type CompareType,
  Provider,
} from './valueSetupCompareContext'

type Props = {
  children: ReactNode
  compareType: CompareType
  compareFilter?: CompareFilter
}

const ValueSetupCompareProvider = ({
  compareType,
  compareFilter,
  children,
}: Props) => (
  <Provider
    value={{
      compareType,
      shouldCompare: compareFilter
        ? (compare) => compare === compareFilter
        : () => true,
    }}
  >
    {children}
  </Provider>
)

export { ValueSetupCompareProvider }
